import { render, staticRenderFns } from "./partnerApply.vue?vue&type=template&id=3edff1c6&scoped=true&"
import script from "./partnerApply.vue?vue&type=script&lang=js&"
export * from "./partnerApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edff1c6",
  null
  
)

export default component.exports